import React from "react";

/**
 * "Sign in with Google" button.
 *
 * Redirects the browser to Emergent's hosted OAuth screen which will hand the
 * user back to `${origin}/auth/callback#session_id=...`. The AuthCallback
 * route then exchanges the session_id for our own JWT.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function GoogleSignInButton({ next = "/", testid = "google-signin-btn" }) {
    const startGoogle = () => {
        // REMINDER: DO NOT HARDCODE THE URL — derive the redirect from window.location only.
        const redirectUrl = window.location.origin + "/auth/callback?next=" + encodeURIComponent(next || "/");
        window.location.href = "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
    };

    return (
        <button
            type="button"
            data-testid={testid}
            onClick={startGoogle}
            className="w-full h-11 rounded-full border border-aduku-border bg-white hover:bg-aduku-bg flex items-center justify-center gap-2.5 text-sm font-semibold text-aduku-navy transition"
        >
            <GoogleGlyph />
            Sign in with Google
        </button>
    );
}

function GoogleGlyph() {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden>
            <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.17-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.91c1.7-1.57 2.69-3.88 2.69-6.62Z" />
            <path fill="#34A853" d="M9 18c2.43 0 4.47-.81 5.96-2.18l-2.91-2.26c-.81.54-1.84.86-3.05.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.34A9 9 0 0 0 9 18Z" />
            <path fill="#FBBC05" d="M3.97 10.71A5.4 5.4 0 0 1 3.68 9c0-.59.1-1.17.29-1.71V4.96H.96A9 9 0 0 0 0 9c0 1.45.35 2.82.96 4.04l3.01-2.33Z" />
            <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58A9 9 0 0 0 9 0 9 9 0 0 0 .96 4.96l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58Z" />
        </svg>
    );
}
